import { logRecevied } from "./loger"

export function setInContextHelper(msg, setContext) {
  logRecevied(msg)
  setContext((ctx) => {
    return { ...ctx, [msg.service]: msg.data }
  })

  if(msg.service ==='userupdate' && msg.data.bet){
    setContext((ctx) => {
      return { ...ctx, userupdateArray:[...ctx.userupdateArray, msg.data] }
    })
  }
}

export function setValueHelper(msg, setRoundValue) {
  logRecevied(msg)
  setRoundValue((ctx) => {
    return { ...ctx, [msg.service]: msg.data }
  })
}

export function addInHistory(msg, setContext) {
  const length = 50
  msg.bet_info && setContext((ctx) => {
    const player_id = ctx.auth.player_id
    const newBetData = [
      {
        ...msg,
        round_id: msg.id,
        betAmount: +msg.bet_info.bet,
        winCoef: +msg.bet_info.coeff,
        winAmount: +msg.bet_info.win,
        currency: msg.bet_info.currency
      },
      ...ctx.history.all
    ]
    const newData = [
      ...ctx.history.all,
      {
        ...msg,
        round_id: msg.id,
        betAmount: +msg.bet_info.bet,
        winCoef: +msg.bet_info.coeff,
        winAmount: +msg.bet_info.win,
        currency: msg.bet_info.currency

      }]

    const all = ctx.placebet.bet ? newBetData : newData

    all.map((el) =>
      el.user_id === player_id
        ? { ...el, user_name: ctx.auth.player_name }
        : el
    ).slice(0, length)

    const my = all.filter((h) => h.user_id === player_id).map((el) => ({ ...el, user_name: ctx.auth.player_name })).slice(0, 18)
    const high = all.filter((h) => h.bet_info.type === 'bigwin').map((el) =>
      el.user_id === player_id
        ? { ...el, user_name: ctx.auth.player_name }
        : el
    ).slice(0, length)
    return {
      ...ctx, 'history': {
        all,
        my,
        high,
      }
    }
  })

}

export const setJackpotInfo = (jackpotInfo, setContext) => {
  setContext(ctx => {
    return { ...ctx, jackpotInfo: jackpotInfo }
  })
}

const setTimer = (timer, setContext) => {
  setContext(ctx => {
    return { ...ctx, timer }
  })
}

const setJackpotState = (jackpotState, setContext) => {
  setContext(ctx => {
    return {
      ...ctx,
      jackpotState: {
        state: jackpotState,
      },
    }
  })
}

export const setJackpotWin = (jackpot, setContext) => {
  const now = new Date()
  setTimer(now.getTime(), setContext)
  setContext(ctx => {
    return {
      ...ctx, jackpot: {
        ...jackpot, progress_bars: {
          solar: jackpot.low,
          galactical: jackpot.mid,
          stellar: jackpot.high,
        }
      }
    }
  })
  if (jackpot.status === "start") {
    setJackpotState("initJackpot", setContext) //here comes prepare for jackpot, stars lightspeed
    setTimeout(() => {
      setJackpotState("initBlackHole", setContext)
      setTimeout(() => {
        setJackpotState("initRound", setContext)
      }, 8000)
    }, 10000)
  } else if (jackpot.status === "finished") {
    setJackpotState("finished", setContext)
  } else {
    setJackpotState("roundStarted", setContext)
  }
}


export const setFullRoundResponce = (e, setContext) => {
  setContext(ctx => {
    return { ...ctx, allPreviousRounds: e.bets }
  })
}


export const setAirdrop = (airdrop, setContext) => {
  setContext(ctx => {
    return {
      ...ctx,
      airdrop,
      balanceUpdate: { ...ctx.balanceUpdate, balance: airdrop.balance },
    }
  })
}



export const placeBetResponce = (placedBet, setContext) => {
  logRecevied({ service: 'placebet', msg: placedBet })
  const index = placedBet.index
  setContext(ctx => {
    return { ...ctx, placebet: placedBet }
  })
  index === "0" &&
    setContext(ctx => {
      return { ...ctx, placedBetFirst: placedBet }
    })
  index === "1" &&
    setContext(ctx => {
      return { ...ctx, placedBetSecond: placedBet }
    })
}


export const jackpotIsActive = (setContext) => {
  setContext(ctx => {
    return { ...ctx, jackpotIsActive: false }
  })
}